// Browser-safe ETS registry adapter using localStorage persistence.

type Package = { id: string; companyId: string; certificateIds: string[]; status: 'submitted'|'processing'|'accepted'|'rejected'; createdAt: string };

const LS_KEY = 'evat:etsPackages';

function load(): { packages: Package[] } {
  try {
    const raw = typeof window !== 'undefined' ? window.localStorage.getItem(LS_KEY) : null;
    return raw ? (JSON.parse(raw) as any) : { packages: [] };
  } catch { return { packages: [] }; }
}
function save(db: { packages: Package[] }) { try { if (typeof window !== 'undefined') window.localStorage.setItem(LS_KEY, JSON.stringify(db)); } catch {} }

export function exportAllowanceEvidence(companyId: string, certificateIds: string[]): Package {
  const db = load();
  const p: Package = { id: `pkg-${Date.now()}`, companyId, certificateIds, status: 'submitted', createdAt: new Date().toISOString() };
  db.packages.push(p); save(db); return p;
}

export function listSubmittedPackages(): Package[] { return load().packages.slice(-50).reverse(); }

export function status(id: string): Package | undefined { return load().packages.find(p=>p.id===id); }



